
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ConsulenzaPage from "../pages/consulenza/page";
import ContrattoPage from "../pages/contratto/page";
import FirmaPage from "../pages/firma/page";
import RegistrazionePage from "../pages/registrazione/page";
import ChiSonoPage from "../pages/chi-sono/page";
import PolizzaMorositaPage from "../pages/polizza-morosita/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/termini/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/consulenza",
    element: <ConsulenzaPage />,
  },
  {
    path: "/contratto",
    element: <ContrattoPage />,
  },
  {
    path: "/firma",
    element: <FirmaPage />,
  },
  {
    path: "/registrazione",
    element: <RegistrazionePage />,
  },
  {
    path: "/polizza-morosita",
    element: <PolizzaMorositaPage />,
  },
  {
    path: "/chi-sono",
    element: <ChiSonoPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/termini",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
